import { connectHook } from 'app/common/components/connect-hook';
import ObjectField from './object-field';
import { useObjectField } from './object-field-hook';

export default connectHook(ObjectField, useObjectField);
